export type ReviewEvidenceGlyphKind = "critical-moment" | "pattern" | "focus" | "verified-line";

const PATHS: Record<ReviewEvidenceGlyphKind, string> = {
  "critical-moment": "M12 3v10m0 5v3M5 6h14l-2 9H7Z",
  pattern: "M5 5h5v5H5Zm9 0h5v5h-5ZM5 14h5v5H5Zm9 0h5v5h-5Z",
  focus: "M12 3v3m0 12v3M3 12h3m12 0h3M8 8h8v8H8Z",
  "verified-line": "m4 13 4 4L20 5M11 19h9",
};

export const ReviewEvidenceGlyph = ({ kind }: { kind: ReviewEvidenceGlyphKind }) => (
  <svg aria-hidden viewBox="0 0 24 24" width="82%" height="82%">
    <path
      d={PATHS[kind]}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);
